import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export const URGENCY = ["low", "medium", "high", "critical"];
export const CATEGORIES = [
    "Discrimination / Racism",
    "Bullying & Harassment",
    "Disciplinary / Grievance",
    "Exclusion from opportunity",
    "Wellbeing & Mental Health",
    "Other",
];
export const STATUSES = ["new", "triaged", "in_progress", "mediation", "resolved", "closed"];
